import type { CardId } from '../../../../model/types.tsx';
import {
	type OptimisticUiMeta,
	beginOptimisticUiMeta,
	commitOptimisticUiMeta,
	revertOptimisticUiMeta,
} from '../../meta/optimistic-ui-meta.tsx';

type CardIds = CardId[];

export type CardsBulkOperationsDeletePayload = {
	cardIds: CardIds;
};

export const CARDS_BULK_OPERATIONS_DELETE_REQUESTS =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_REQUEST' as const;

export type CardsBulkOperationsDeleteRequestsAction = {
	type: typeof CARDS_BULK_OPERATIONS_DELETE_REQUESTS;
	payload: CardsBulkOperationsDeletePayload[];
	meta: OptimisticUiMeta;
};

export const cardsBulkOperationsDeleteRequests = (
	payload: CardsBulkOperationsDeletePayload[],
): CardsBulkOperationsDeleteRequestsAction => ({
	type: CARDS_BULK_OPERATIONS_DELETE_REQUESTS,
	payload,
	meta: beginOptimisticUiMeta(),
});

export const CARDS_BULK_OPERATIONS_DELETE_SUCCESS =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_SUCCESS' as const;

export type CardsBulkOperationsDeleteSuccessAction = {
	type: typeof CARDS_BULK_OPERATIONS_DELETE_SUCCESS;
	payload: CardIds;
	meta: OptimisticUiMeta;
};

export const cardsBulkOperationsDeleteSuccess = (
	optimisticId: string,
	payload: CardIds,
): CardsBulkOperationsDeleteSuccessAction => ({
	type: CARDS_BULK_OPERATIONS_DELETE_SUCCESS,
	payload,
	meta: commitOptimisticUiMeta(optimisticId),
});

export const CARDS_BULK_OPERATIONS_DELETE_FAILURE =
	'state.actions.cards.bulk-operations.CARDS_BULK_OPERATIONS_DELETE_FAILURE' as const;

export type CardsBulkOperationsDeleteFailureAction = {
	type: typeof CARDS_BULK_OPERATIONS_DELETE_FAILURE;
	payload: CardIds;
	meta: OptimisticUiMeta;
};

export const cardsBulkOperationsDeleteFailure = (
	optimisticId: string,
	payload: CardIds,
): CardsBulkOperationsDeleteFailureAction => ({
	type: CARDS_BULK_OPERATIONS_DELETE_FAILURE,
	payload,
	meta: revertOptimisticUiMeta(optimisticId),
});

export type Action =
	| CardsBulkOperationsDeleteRequestsAction
	| CardsBulkOperationsDeleteSuccessAction
	| CardsBulkOperationsDeleteFailureAction;
